import { AccountInfo, InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";

export default class LoginService {

    getAccessToken = async (instance: IPublicClientApplication, account: AccountInfo) => {
        const accessTokenRequest = {
            scopes: ["api://d3df106d-b0da-4981-a1a8-2672c8b1b26b/access_as_user"],
            account: account,
        };

        try {
            let accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
            let accessToken = accessTokenResponse.accessToken;
            return accessToken;
        }
        catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                instance
                    .acquireTokenPopup(accessTokenRequest)
                    .then(function (accessTokenResponse) {
                        // Acquire token interactive success
                        let accessToken = accessTokenResponse.accessToken;
                        return accessToken;
                    })
                    .catch(function (error) {
                        // Acquire token interactive failure
                        console.log(error);
                        return "";
                    });
            }
        }

    }
} 